module.exports = __webpack_public_path__ + "img/steinaker.5460a0c8.png";